var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeezerColorLightPadding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 50,
    viewBox: "0 0 200 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Deezer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "deezer-color"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Deezer_logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8175",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.0045 35C72.9921 35 70.2917 32.3613 70.2917 27.9524C70.2917 23.4775 73.1124 20.7838 77.0264 20.7948C79.0271 20.7948 80.6233 21.4545 81.487 22.9277V14H85.2917V35H81.6292V32.966C80.6889 34.4393 79.0052 35 77.0045 35ZM77.8573 32.0424C79.9017 32.0424 81.6073 30.4702 81.6073 27.9524C81.6073 25.4126 79.9017 23.7853 77.8573 23.7853C75.7472 23.7853 74.1073 25.3906 74.1073 27.9524C74.1073 30.4702 75.7363 32.0424 77.8573 32.0424Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8177",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.8034 32.0595C96.5343 32.0595 97.6338 31.2595 98.0693 29.6595L101.292 30.9243C100.312 33.6378 98.0802 35 94.7925 35C90.4379 35 87.2917 32.3405 87.2917 27.9081C87.2917 23.9297 90.1439 21 94.2917 21C98.1782 21 100.813 23.1622 100.813 27C100.813 27.6162 100.758 28.1784 100.638 28.7081H91.0911C91.1346 30.8486 92.7894 32.0595 94.8034 32.0595ZM94.3026 23.7459C92.7458 23.7459 91.4503 24.6541 91.0911 26.2H97.1331L97.1548 26.0811C97.1548 24.6541 96.0009 23.7459 94.3026 23.7459Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8179",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.803 32.0595C110.534 32.0595 111.634 31.2595 112.069 29.6595L115.292 30.9243C114.312 33.6378 112.08 35 108.792 35C104.438 35 101.292 32.3405 101.292 27.9081C101.292 23.9297 104.144 21 108.292 21C112.178 21 114.813 23.1622 114.813 27C114.813 27.6162 114.758 28.1784 114.638 28.7081H105.091C105.135 30.8486 106.789 32.0595 108.803 32.0595ZM108.303 23.7459C106.746 23.7459 105.45 24.6541 105.091 26.2H111.133L111.155 26.0811C111.155 24.6541 110.001 23.7459 108.303 23.7459Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8181",
    d: "M127.292 35V31.5946H119.775L127.086 24.1135V21H115.518V24.2432H122.582L115.292 31.7568V35H127.292Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8183",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.803 32.0595C137.534 32.0595 138.634 31.2595 139.069 29.6595L142.292 30.9243C141.312 33.6378 139.08 35 135.792 35C131.438 35 128.292 32.3405 128.292 27.9081C128.292 23.9297 131.144 21 135.292 21C139.178 21 141.813 23.1622 141.813 27C141.813 27.6162 141.758 28.1784 141.638 28.7081H132.091C132.135 30.8486 133.789 32.0595 135.803 32.0595ZM135.303 23.7459C133.746 23.7459 132.45 24.6541 132.091 26.2H138.133L138.155 26.0811C138.155 24.6541 137.001 23.7459 135.303 23.7459Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8185",
    x: 63.2917,
    y: 20,
    width: 4,
    height: 4,
    fill: "#40AB5D"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8192",
    x: 63.2917,
    y: 23,
    width: 4,
    height: 4,
    fill: "url(#paint0_linear_107_350)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8199",
    x: 63.2917,
    y: 28,
    width: 4,
    height: 4,
    fill: "url(#paint1_linear_107_350)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8206",
    x: 45.2917,
    y: 31,
    width: 4,
    height: 4,
    fill: "url(#paint2_linear_107_350)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8213",
    x: 50.2917,
    y: 31,
    width: 4,
    height: 4,
    fill: "url(#paint3_linear_107_350)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8220",
    x: 56.2917,
    y: 31,
    width: 4,
    height: 4,
    fill: "url(#paint4_linear_107_350)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8227",
    x: 63.2917,
    y: 31,
    width: 4,
    height: 4,
    fill: "url(#paint5_linear_107_350)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8234",
    x: 56.2917,
    y: 28,
    width: 4,
    height: 4,
    fill: "url(#paint6_linear_107_350)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8241",
    x: 50.2917,
    y: 28,
    width: 4,
    height: 4,
    fill: "url(#paint7_linear_107_350)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8248",
    x: 50.2917,
    y: 23,
    width: 4,
    height: 4,
    fill: "url(#paint8_linear_107_350)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8250",
    d: "M150.682 25.8183C150.682 25.959 150.682 26.2189 150.682 26.2189H154.292C154.292 26.2189 154.292 25.5259 154.292 25.1469C154.292 22.7432 152.812 21 150.33 21C148.733 21 147.604 21.7904 147.019 23.1005V21H143.292V35H147.019V25.9807C147.019 24.5514 147.775 23.761 148.935 23.761C150 23.7718 150.682 24.7896 150.682 25.8183Z",
    fill: "black"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_107_350",
    x1: 67.3579,
    y1: 27.0157,
    x2: 67.3203,
    y2: 22.9225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#358C7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5256,
    stopColor: "#33A65E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_107_350",
    x1: 65.0266,
    y1: 33.8543,
    x2: 69.146,
    y2: 30.2669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222B90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#367B99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_107_350",
    x1: 45.2924,
    y1: 34.9999,
    x2: 49.2891,
    y2: 34.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_107_350",
    x1: 50.2961,
    y1: 34.9999,
    x2: 54.2928,
    y2: 34.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC1953"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_107_350",
    x1: 56.2905,
    y1: 34.9999,
    x2: 60.2872,
    y2: 34.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC1953"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#241284"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_107_350",
    x1: 63.2895,
    y1: 34.9999,
    x2: 67.2862,
    y2: 34.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222B90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3559A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_107_350",
    x1: 57.2104,
    y1: 33.2346,
    x2: 61.5225,
    y2: 31.0794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC1953"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#241284"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_107_350",
    x1: 48.8222,
    y1: 30.8098,
    x2: 53.1034,
    y2: 33.4731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00266984,
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#CE1938"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_107_350",
    x1: 48.0102,
    y1: 24.0408,
    x2: 51.335,
    y2: 29.2845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00266984,
    stopColor: "#FFD100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD5A22"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeezerColorLightPadding);
export default __webpack_public_path__ + "static/media/deezer-color-light-padding.a9e3f45349a32779c0fc65bc0d71a147.svg";
export { ForwardRef as ReactComponent };